import React from 'react';
import { ViewabilityConfig, ViewToken } from 'react-native';

const useViewableItems = (
  viewAreaCoveragePercentThreshold = 30,
  minimumViewTime = 300
) => {
  const viewabilityConfig: ViewabilityConfig = React.useMemo(
    () => ({
      viewAreaCoveragePercentThreshold,
      minimumViewTime,
    }),
    [minimumViewTime, viewAreaCoveragePercentThreshold]
  );
  const [currentVisibleIndex, setCurrentVisibleIndex] = React.useState<number>(
    0
  );
  const handleViewableItemsChanged = React.useCallback(
    ({
      viewableItems,
    }: {
      viewableItems: Array<ViewToken>;
      changed: Array<ViewToken>;
    }) => {
      if (viewableItems && viewableItems.length > 0) {
        if (viewableItems[0].index !== null) {
          setCurrentVisibleIndex(viewableItems[0].index);
        } else {
          setCurrentVisibleIndex(0);
        }
      }
    },
    []
  );

  return React.useMemo(
    () => ({
      viewabilityConfig,
      handleViewableItemsChanged,
      currentVisibleIndex,
    }),
    [currentVisibleIndex, handleViewableItemsChanged, viewabilityConfig]
  );
};

export default useViewableItems;
